var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9062 9.13333V6C13.9062 3.8 12.0922 2 9.875 2C7.65781 2 5.84375 3.8 5.84375 6V9.13333C5.0375 10.0667 4.5 11.3333 4.5 12.6667C4.5 15.6 6.91875 18 9.875 18C12.8313 18 15.25 15.6 15.25 12.6667C15.25 11.3333 14.7125 10.0667 13.9062 9.13333ZM7.1875 8.06667V6C7.1875 4.53333 8.39687 3.33333 9.875 3.33333C11.3531 3.33333 12.5625 4.53333 12.5625 6V8.06667C11.7562 7.6 10.8828 7.33333 9.875 7.33333C8.86719 7.33333 7.99375 7.6 7.1875 8.06667ZM10.5469 13.1333V14.6667C10.5469 15.0667 10.2781 15.3333 9.875 15.3333C9.47188 15.3333 9.20312 15.0667 9.20312 14.6667V13.1333C8.8 12.9333 8.53125 12.4667 8.53125 12C8.53125 11.2667 9.13594 10.6667 9.875 10.6667C10.6141 10.6667 11.2188 11.2667 11.2188 12C11.2188 12.4667 10.95 12.9333 10.5469 13.1333Z",
    fill: "#6B8299"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockGrey);
export default __webpack_public_path__ + "static/media/lock-grey.81ae44852abfda99469a0aa64570d826.svg";
export { ForwardRef as ReactComponent };